import Component from './component';

class ScrollBar extends Component {
    constructor(el, opts) {
        super(el, opts);

        this.view = Object.assign({}, this.view, {
            scroller: this.qs('[data-scroller]'),
        });
    }

    update(delta, h) {
        const elCont = this.view.scroller.clientHeight;
        const winH = window.innerHeight - elCont;
        const translate = ((winH * delta) / h);
        let final;

        if (translate < 0) {
            final = 0;
        } else if (translate > h) {
            final = winH;
        } else {
            final = translate;
        }

        this.view.scroller.style.transform = `translate3d(0, ${final}px, 0)`;
    }
}

export default ScrollBar;



/** WEBPACK FOOTER **
 ** ./components/scrollbar.js
 **/